export default "__VITE_ASSET__wSHRZQ4X__"